/**
 * ob-collection.js
 * Main entry point for collection page functionality
 */

/**
 * /assets/
  ├── ob-collection.js         # Main entry point & initialization
  ├── ob-nosto-api.js          # Nosto API integration
  ├── ob-collection-data.js    # Vue component data/state
  ├── ob-collection-methods.js # Core Vue methods
  ├── ob-facet-methods.js      # Filtering/faceting logic
  ├── ob-ui-helpers.js         # UI utility functions
  ├── ob-hero-slots.js         # Hero slot positioning
 */

import { searchNosto, trackNosto } from './ob-nosto-api.js';
import { getCollectionData } from './ob-collection-data.js';
import { scrollToAnchorContainingURL } from './ob-ui-helpers.js';
import { getCollectionMethods } from './ob-collection-methods.js';
import { initSecondaryFilterCards } from './ob-secondary-filter-cards.js';

import { loadHeroSlot1, loadHeroSlot2, heroCustomAdd, heroCustomMobAdd } from './ob-hero-slots.js';

// Initialize global object
if (typeof ob === 'undefined') {
  var ob = {};
}

// Make hero functions globally available
window.loadHeroSlot1 = loadHeroSlot1;
window.loadHeroSlot2 = loadHeroSlot2;
window.heroCustomAdd = heroCustomAdd;
window.heroCustomMobAdd = heroCustomMobAdd;

// Nosto integration object
ob.nosto = {
  init: function (params) {
    const currencyCodeToKeyMap = Object.freeze({
      GB: 'custom-private_sale_discount_price',
      EU: 'custom-private_sale_discount_price_eu',
      USA: 'custom-private_sale_discount_price_us',
      'AUSTRALIA-NEW-ZEALAND': 'custom-private_sale_discount_price_au',
      UAE: 'custom-private_sale_discount_price_uae',
      ROW: 'custom-private_sale_discount_price',
      THAILAND: 'custom-private_sale_discount_price_th',
      SWITZERLAND: 'custom-private_sale_discount_price_ch',
    });

    const Collection = {
      name: 'Collection Page',
      data() {
        return getCollectionData();
      },
      created() {
        this.checkIfMobile();
      },
      mounted() {
        this.collection(window.collectionId ? window.collectionId : '484793581787');

        window.addEventListener('pageshow', (event) => {
          if (event.persisted) {
            const cachedProduct = localStorage.getItem('pdpURL');
            if (cachedProduct) {
              scrollToAnchorContainingURL(cachedProduct);
            }
          }
        });
      },
      beforeDestroy() {
        window.removeEventListener('resize', this.checkOverflow);
      },
      methods: getCollectionMethods(currencyCodeToKeyMap, searchNosto, trackNosto),
      computed: {
        resultsButtonHtml() {
          const count = this.totalProducts || 0;
          if (!this.mobileApplyTemplate) {
            return '';
          }
          return this.mobileApplyTemplate.replace('[count]', count);
        }
      }
    };

    const CollectionPage = Vue.createApp(Collection).mount('#Collection');
    initSecondaryFilterCards(CollectionPage);
  },
};

// Initialize
ob.nosto.init();

export default ob;
